import { render, staticRenderFns } from "./bestseller-buttons.vue?vue&type=template&id=216be29c&scoped=true&"
import script from "./bestseller-buttons.vue?vue&type=script&lang=js&"
export * from "./bestseller-buttons.vue?vue&type=script&lang=js&"
import style0 from "./bestseller-buttons.vue?vue&type=style&index=0&id=216be29c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216be29c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default})
